import { render, staticRenderFns } from "./ScheduledPayments.vue?vue&type=template&id=4dc8dfd6&"
import script from "./ScheduledPayments.vue?vue&type=script&lang=ts&"
export * from "./ScheduledPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports